<template>
  <div class="liveBox" ref="scrollEle">
    <Download></Download>
    <div class="top">
      <div class="replayBox" v-if="playInfo">
        <CourseVideo :playInfo="playInfo"></CourseVideo>
      </div>
      <div class="live" v-show="!playInfo">
        <div v-show="info.livestatus == 1001 || info.advertisingurl">
          <video
            class="video video-js vjs-big-play-centered"
            webkit-playsinline="true"
            playsinline="true"
            ref="video"
            :poster="info.coverimg"
          ></video>
        </div>
        <img
          v-show="info.livestatus != 1001 && info.image && !info.advertisingurl"
          :src="info.image"
          alt=""
        />
      </div>
    </div>
    <div class="nav">
      <ul>
        <li :class="navIndex == 0 ? 'active' : ''" @click="switchNav(0)">
          详情
        </li>
        <li :class="navIndex == 1 ? 'active' : ''" @click="switchNav(1)">
          互动
        </li>
      </ul>
    </div>
    <div class="main">
      <swiper ref="mySwiper" :options="swiperOption" class="swiper-wrapper">
        <swiper-slide>
          <div class="detail">
            <div class="timeBox">
              <i class="leftLabel label"></i>
              <i class="rightLabel label"></i>
              <p class="title">{{ info.name }}</p>
              <i class="liveLabel"></i>
              <p class="liveTime">
                {{
                  info.livestatus == 1000
                    ? "距离" +
                      util.changeTime({
                        time: info.starttime,
                        line: "text",
                        showMin: true,
                      }) +
                      "开播还有"
                    : "直播时间：" +
                      util.changeTime({
                        time: info.starttime,
                        line: "text",
                        showMin: true,
                      })
                }}
              </p>
              <div class="statusBox" v-if="info">
                <div
                  class="countdown"
                  v-if="info.livestatus == 1000 && endTime >= systemtime"
                >
                  <span>{{ days }}</span>
                  <em>天</em> <span>{{ hours }}</span> <em>时</em>
                  <span>{{ minutes }}</span> <em>分</em>
                  <span>{{ seconds }}</span>
                  <em>秒</em>
                </div>
                <div v-else>
                  {{ info.livestatus | showLiveTatus(this) }}
                </div>
              </div>
              <div class="opation">
                <p
                  class="tip"
                  v-if="info.livestatus == 1000 && endTime >= systemtime"
                  @click="opation('liveTip')"
                >
                  <span>开播提醒</span>
                </p>
                <!-- v-if="info.livestatus != 1002" -->
                <p class="online">
                  {{ info.livestatus | showWatchCount(this) }}
                </p>
              </div>
            </div>
            <div class="common teachers" v-if="info.organizationid">
              <div class="commonTop">
                <span>主办单位</span>
              </div>
              <div class="commonContent" @click="opation('agency')">
                <Components type="agency" :data="agencyInfo"></Components>
              </div>
            </div>
            <div class="common introduction">
              <div class="commonTop">
                <span>直播简介</span>
              </div>
              <div class="commonContent" v-html="info.profile"></div>
            </div>
          </div>
        </swiper-slide>
        <swiper-slide>
          <div class="loginBox">
            <p>前往app参与互动</p>
            <span @click="down()">去下载</span>
          </div>
        </swiper-slide>
      </swiper>
    </div>
  </div>
</template>

<script>
import CourseVideo from "@/components/courseVideo";
import Download from "@/components/download";
import Components from "../serve/components/components.vue";
export default {
  metaInfo() {
    return {
      title: this.info.name,
    };
  },

  data() {
    return {
      activityId: "",
      info: "",
      navIndex: 0,
      swiperOption: {
        noSwiping: true,
        autoHeight: true,
        onSlideChangeStart: function (swiper) {
          this.navIndex = swiper.activeIndex;
        }.bind(this),
      },
      days: "",
      hours: "",
      minutes: "",
      seconds: "",
      likeCount: 0,
      watchNumber: 0,

      player: "",
      clickIndex: 0,
      timeStop: "",
      playInfo: "",
      countdownStop: "",
      endTime: "",
      systemtime: "",

      agencyInfo: "",
    };
  },
  components: {
    CourseVideo,
    Download,
    Components,
  },
  mounted() {
    this.activityId = this.$route.query.activityId
      ? this.$route.query.activityId
      : "";
    this.getLive();
  },
  beforeDestroy() {
    clearInterval(this.infoTime);
    clearInterval(this.timeStop);
  },
  filters: {
    showLiveTatus: function (livestatus, _this) {
      if (
        _this.info &&
        livestatus == 1000 &&
        _this.endTime < _this.systemtime
      ) {
        return "请耐心等待";
      }
      return livestatus == 1001
        ? "直播中"
        : livestatus == 1003
        ? "已结束，可回放"
        : "已结束";
    },
    showWatchCount: function (livestatus, _this) {
      var count =
        _this.util.showCount(
          livestatus == 1000 ? _this.info.reservecount : _this.watchNumber
        ) +
        "人" +
        (livestatus == 1001 ? "在线" : livestatus == 1000 ? "已预约" : "观看");
      return count;
    },
  },
  methods: {
    getLive() {
      var _this = this;
      this.$post("/gart-common-api/api/scm/activity/queryLiveActivityApp", {
        activityid: this.activityId,
      }).then((res) => {
        if (this.util.processingData(res)) {
          if (res.code == 1) {
            var data = res.data;
            _this.info = data;
            this.groupID = data.groupid;
            this.ownerAccount = data.ownerAccount;
            this.agencyInfo = {
              logo: data.organizationLogo,
              name: data.organizationname,
              businesshours: data.organizationHour,
              address: data.organizationAddress,
            };
            this.getlike();
            this.switchNav(0);
            if (data.livestatus == 1000) {
              this.systemtime = res.systemtime;
              this.endTime = data.starttime;
              if (this.endTime >= this.systemtime) {
                this.countdownStop = true;
                this.countdown();
                this.timeStop = setInterval(() => {
                  _this.systemtime += 1000;
                  if (_this.endTime < _this.systemtime) {
                    if (!_this.infoTime) {
                      _this.getInfoStep();
                      clearInterval(_this.timeStop);
                    }
                  } else {
                    _this.countdown();
                  }
                }, 1000);
              } else {
                clearInterval(this.infoTime);
                clearInterval(this.timeStop);
              }
              if (data.advertisingurl) {
                this.showLive(data.advertisingurl);
              }
            }
            if (data.livestatus == 1001) {
              if (data.rtmpplayurl) {
                this.showLive(data.rtmpplayurl);
              } else {
                this.showLive(data.livepayurl);
              }
              this.timeStop = setInterval(function () {
                _this.getlike();
              }, 10000);
            } else if (data.livestatus == 1003) {
              if (data.video) {
                this.playInfo = Object.assign(
                  { poster: data.poster },
                  data.video
                );
              } else {
                if (data.advertisingurl) {
                  this.showLive(data.advertisingurl);
                }
                this.util.toast({ msg: "暂无回放内容" });
              }
            } else if (data.livestatus == 1002) {
              if (data.advertisingurl) {
                this.showLive(data.advertisingurl);
              }
            } else {
              if (data.advertisingurl) {
                this.showLive(data.advertisingurl);
              }
            }
            this.shareLink();
          } else {
            this.util.toast({ msg: res.message });
          }
        }
      });
    },
    countdown() {
      var startTime = this.systemtime;
      var endTime = this.endTime;
      var time = parseInt(endTime - startTime);
      var days = Math.floor(time / (1000 * 60 * 60 * 24));
      var hours = Math.floor((time / (1000 * 60 * 60)) % 24);
      var minutes = Math.floor((time / (1000 * 60)) % 60);
      var seconds = Math.floor((time / 1000) % 60);
      this.days = days >= 10 ? days : "0" + days;
      this.hours = hours >= 10 ? hours : "0" + hours;
      this.seconds = seconds >= 10 ? seconds : "0" + seconds;
      this.minutes = minutes >= 10 ? minutes : "0" + minutes;
    },
    getInfoStep() {
      var _this = this;
      this.infoTime = setInterval(function () {
        _this.getLive();
      }, 2000);
    },
    showLive(url) {
      var _this = this;
      this.player = videojs(_this.$refs.video, {
        loop: false,
        controls: true, //是否显示空间
        autoplay: true, //自动播放
        preload: "auto", //播放器加载完是否下载视频 （auto）浏览器支持即会下载  （metadata）仅加载视频元数据 （none）用户点击播放下载视频
        liveui: true,
        sources: [
          {
            src: url,
          },
        ],
        poster: "", //封面图
      });
    },
    down() {
      this.util.downLoad(this);
    },
    shareLink() {
      var _this = this;
      var url =
        _this.$store.state.state.shareUrl +
        "#/h5/course/live?activityId=" +
        _this.activityId;
      var data = {
        title: _this.info.sharetitle,
        desc: _this.info.sharesummary ? this.info.sharesummary : "",
        url: url,
        imgUrl: _this.info.shareicon,
      };
      this.util.shareLink(_this, data).then(function () {
        // _this.shareCount();
      });
    },
    getlike() {
      this.$post("/gart-common-api/api/scm/activity/queryActivityWatch", {
        liveactivityid: this.info.liveactivityid,
      }).then((res) => {
        let watchNumber = res.data
          ? res.data.watchnumber || res.data.totalwatchnumber
          : 0;
        // this.watchNumber =res.data && res.data.watchnumber? res.data.watchnumber: 0;
        this.watchNumber = watchNumber;
        //res.data && res.data.toallikenumber ? res.data.toallikenumber : 0;
      });
    },
    opation(type) {
      var url = "",
        obj = "";
      switch (type) {
        case "liveTip":
          url = "/h5/downLoad";
          break;
        case "subscribe":
          url = "/h5/downLoad";
          break;
        case "agency":
          url = "/h5/serve/agency";
          obj = { teamInfoId: this.info.organizationid };
          break;
        default:
          break;
      }
      if (url) {
        this.$router.push({
          path: url,
          query: obj,
        });
      }
    },
    switchNav(index) {
      this.navIndex = index;
      this.$refs.mySwiper.swiper.slideTo(index, 200, false);
    },
  },
};
</script>

<style lang="scss" scoped>
.liveBox {
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  background: #f4f4f7;
  display: flex;
  flex-direction: column;
  .top {
    width: 100%;
    height: 56vw;
    background: #000;
    .live {
      width: 100%;
      height: 56vw;
      overflow: hidden;
      .video {
        width: 100%;
        height: 100%;
        video {
          width: 100%;
          height: 100%;
        }
      }
      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
      > div {
        width: 100%;
        height: 100%;
      }
    }
    .replayBox {
      width: 100%;
      height: 56vw;
      .video {
        width: 100%;
        height: 100%;
      }
    }
  }
  .nav {
    background: #fff;
    border-bottom: 0.5px solid rgba(151, 151, 151, 0.2);
    ul {
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: space-around;
      li {
        padding: 16px 0;
        font-size: 16px;
        line-height: 22px;
        color: rgba(45, 45, 45, 1);
      }
      li.active {
        color: rgba(45, 45, 45, 1);
        font-weight: bolder;
        position: relative;
      }
      li.active::before {
        content: " ";
        display: inline-block;
        width: 20px;
        height: 4px;
        position: absolute;
        left: 50%;
        margin-left: -10px;
        bottom: 0;
        background: rgba(201, 76, 76, 1);
        border-radius: 2px;
      }
    }
  }
  .main {
    flex: 1;
    overflow: auto;
    .swiper-wrapper {
      height: 100%;
      width: 100%;
      /deep/ .swiper-slide {
        height: 100%;
        width: 100%;
        overflow: auto;
      }
    }
    .detail {
      margin: 16px;
      padding-bottom: 100px;
      .timeBox {
        background: #fff;
        box-shadow: 0px 10px 15px 0px rgba(0, 0, 0, 0.06);
        padding: 35px 0 24px;
        position: relative;
        text-align: center;
        border-radius: 8px;
        .label {
          display: inline-block;
          width: 14px;
          height: 14px;
          border-radius: 50%;
          background: RGBA(237, 237, 240, 1);
          position: absolute;
          top: 4px;
        }
        .label::before {
          content: " ";
          display: inline-block;
          width: 8px;
          height: 16px;
          border-radius: 4px;
          background: #ccccd2;
          position: absolute;
          top: -10px;
          left: 50%;
          margin-left: -4px;
        }
        .leftLabel {
          left: 108px;
        }
        .rightLabel {
          right: 108px;
        }
        .title {
          font-size: 18px;
          line-height: 25px;
          color: rgba(45, 45, 45, 1);
          font-weight: bolder;
          margin: 0 12px;
        }
        .liveLabel {
          display: inline-block;
          margin: 24px 0;
          width: 56px;
          height: 26px;
          background: url(../../../assets/img/h5/live.png) no-repeat;
          background-size: 56px 26px;
        }
        .liveTime {
          color: rgba(45, 45, 45, 0.4);
          font-size: 12px;
          line-height: 15px;
          font-weight: 400;
        }
        .statusBox {
          font-size: 22px;
          line-height: 30px;
          div {
            margin-top: 16px;
          }
          .countdown {
            margin-top: 4px;
          }
          span {
            font-size: 36px;
            line-height: 46px;
            color: rgba(45, 45, 45, 1);
            font-weight: bold;
            text-align: center;
            display: inline-block;
          }
          em {
            font-size: 11px;
            line-height: 16px;
            color: rgba(52, 55, 55, 0.4);
          }
          em:not(:last-child) {
            margin-right: 9px;
          }
        }
        .opation {
          border-top: 0.5px dashed rgba(212, 212, 212, 1);
          margin-top: 16px;
          .tip {
            padding: 16px 0 0;
            span {
              display: block;
              margin: 0 32px;
              background: linear-gradient(315deg, #d44c48 0%, #ee816d 100%);
              border-radius: 22px;
              font-size: 14px;
              line-height: 20px;
              color: rgba(255, 255, 255, 1);
              padding: 12px 0;
              text-align: center;
            }
          }
          .online {
            color: rgba(45, 45, 45, 0.4);
            font-size: 12px;
            line-height: 17px;
            margin-top: 16px;
          }
        }
      }
      .common {
        margin-top: 24px;
        .commonTop {
          position: relative;
          span {
            font-size: 14px;
            line-height: 20px;
            color: rgba(53, 54, 60, 0.6);
            position: relative;
            z-index: 10;
            background: rgba(244, 244, 247, 1);
            padding-right: 8px;
            font-weight: bolder;
          }
        }
        .commonTop::before {
          content: " ";
          position: absolute;
          top: 50%;
          left: 0;
          right: 0;
          height: 1px;
          background: rgba(224, 224, 224, 0.5);
          z-index: -1;
        }
        .commonContent {
          margin-top: 20px;
          background: #fff;
          border-radius: 8px;
        }
      }
      .teachers {
        .commonContent {
          display: flex;
          flex-direction: row;
          align-items: center;
          padding: 12px 16px;
          // img {
          //   width: 64px;
          //   height: 64px;
          //   border-radius: 50%;
          //   object-fit: cover;
          // }
          // .info {
          //   flex: 1;
          //   overflow: hidden;
          //   margin-left: 16px;
          //   position: relative;
          //   .name {
          //     font-size: 14px;
          //     line-height: 20px;
          //     color: rgba(45, 45, 45, 1);
          //     font-weight: 600;
          //   }
          //   .title {
          //     font-size: 12px;
          //     line-height: 17px;
          //     color: rgba(45, 45, 45, 1);
          //     margin-top: 4px;
          //   }
          //   .count {
          //     color: rgba(129, 129, 129, 1);
          //     margin-top: 4px;
          //     font-size: 12px;
          //     line-height: 17px;
          //   }
          // }
          // .subscribe {
          //   margin-left: 18px;
          //   span {
          //     font-size: 14px;
          //     line-height: 20px;
          //     color: rgba(201, 76, 76, 1);
          //     font-weight: 600;
          //     background: rgba(201, 76, 76, 0.15);
          //     border-radius: 16px;
          //     padding: 6px 18px;
          //   }
          // }
        }
      }
      .introduction {
        .commonContent {
          overflow-x: hidden;
          padding: 24px;
          img,
          image {
            max-width: 100%;
          }
        }
      }
    }
    .loginBox {
      height: 100%;
      overflow: hidden;
      display: flex;
      flex-direction: column;
      align-items: center;
      background: #f4f4f7;
      padding-top: 50px;
      p {
        font-size: 16px;
        line-height: 22px;
        color: rgba(45, 45, 45, 0.4);
        font-weight: 400;
      }
      span {
        display: inline-block;
        background: rgba(201, 55, 61, 1);
        color: #fff;
        font-size: 14px;
        line-height: 20px;
        color: #ffffff;
        text-align: center;
        border-radius: 6px;
        padding: 12px 32px;
        margin-top: 24px;
      }
    }
  }
}
</style>
